import QuestionsLoanForgiveness from 'tio-employee/components/questions/loan-forgiveness';

<template>
  <QuestionsLoanForgiveness
    @indexRoute="authenticated.pslf.questions.index"
    @incomeRoute="authenticated.pslf.questions.income-driven"
    @teacherRoute="authenticated.pslf.questions.teacher"
  >
    {{outlet}}
  </QuestionsLoanForgiveness>
</template>
